import { render } from "./RareDiseaseSpecificQuestions.vue?vue&type=template&id=6ca19b1e&scoped=true"
import script from "./RareDiseaseSpecificQuestions.vue?vue&type=script&lang=js"
export * from "./RareDiseaseSpecificQuestions.vue?vue&type=script&lang=js"

import "./RareDiseaseSpecificQuestions.vue?vue&type=style&index=0&id=6ca19b1e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca19b1e"]])

export default __exports__